import { Instagram, Youtube, ExternalLink } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";
import { Link } from "react-router-dom";

// Custom TikTok Icon Component
const TikTokIcon = ({ className }: { className?: string }) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
  </svg>
);

const Footer = () => {
  const { t } = useLanguage();
  const currentYear = new Date().getFullYear();
  const socialLinks = [
    { icon: Instagram, href: "https://www.instagram.com/nica.alejandro/", label: "@nica.alejandro", color: "hover:text-pink-500" },
    { icon: Youtube, href: "https://www.youtube.com/@nicaalejandroo", label: "@nicaalejandroo", color: "hover:text-red-500" },
    { icon: TikTokIcon, href: "https://www.tiktok.com/@coach.alejandr", label: "@coach.alejandr", color: "hover:text-black dark:hover:text-white" }
  ];

  return (
    <footer className="bg-card/50 border-t border-border py-16">
      <div className="container mx-auto px-4">
        <div className="text-center">
          
          {/* Logo and Tagline */}
          <div className="mb-8">
            <h3 className="text-3xl font-black gradient-text mb-2">{t('navigation.logo')}</h3>
            <p className="text-muted-foreground">
              {t('footer.tagline')}
            </p>
          </div>

          {/* Social Links */}
          <div className="flex flex-wrap justify-center items-center gap-4 sm:gap-6 mb-8">
            {socialLinks.map((link, index) => {
              const Icon = link.icon;
              return (
                <a
                  key={index}
                  href={link.href}
                  className="flex items-center gap-2 text-muted-foreground hover:text-primary transition-colors"
                  aria-label={link.label}
                >
                  <Icon className="h-5 w-5" />
                  <span className="text-sm hidden sm:block">{link.label}</span>
                </a>
              );
            })}
          </div>


          {/* Links */}
          <div className="flex flex-wrap justify-center items-center gap-4 sm:gap-6 text-sm text-muted-foreground mb-8">
            <a href="#about" className="hover:text-primary transition-colors">{t('footer.links.about')}</a>
            <a href="#faq" className="hover:text-primary transition-colors">{t('footer.links.faq')}</a>
          </div>

          {/* Bottom */}
          <div className="border-t border-border pt-8">
            <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-muted-foreground">
              <div>
                {t('footer.legal.copyright').replace('{year}', currentYear.toString())}
              </div>
              <div className="flex gap-4">
                <Link to="/privacy-policy" className="hover:text-primary transition-colors">{t('footer.legal.privacy')}</Link>
                <Link to="/terms-conditions" className="hover:text-primary transition-colors">{t('footer.legal.terms')}</Link>
              </div>
            </div>
            
            <div className="mt-4 text-xs text-muted-foreground">
              {t('footer.legal.disclaimer')}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;